angular.
module("dx.webapp.cookies").
factory("dxLanguageCookieSetter", function setCookie(
	$cookies
) {
	"use strict";
	return function setLanguageCookie(lang) {
		var expires = new Date();
		expires.setFullYear(expires.getFullYear() + 1);
		return $cookies.putObject("language", {locale: lang}, {path: "/", expires: expires});
	};
});
